import React from "react";
import womenImage from "../../assets/images/women-image.png";
import "./CallAdvisorBanner.scss";


function CallAdvisorBanner({
  title = "Fast & Easy. Get started Now!",
  subtitle = "Give us a call to speak to one of our advisor",
  phone = "8000 77 777",
  advisorImage = womenImage,
}) {
  return (
    <section className="call-advisor" aria-label="Call advisor">
      <div className="call-advisor__top" aria-hidden="true">
        <div className="call-advisor__linework" />
      </div>

      <div className="call-advisor__banner">
        <div className="call-advisor__purple" aria-hidden="true" />
        <img className="call-advisor__person" src={advisorImage} alt="" />
        <div className="call-advisor__copy">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <a
          className="call-advisor__phone"
          href={`tel:${phone.replace(/\s/g, "")}`}
        >
          {phone}
        </a>
      </div>
    </section>
  );
}

export default CallAdvisorBanner;
